import { apiClient } from "./client";

/**
 * Kim olduğumuzu öğrenmek için backend'in /api/saas/me endpoint'ini çağırır.
 * `profile.is_super_admin` SuperAdminGuard'da okunan tek alan; oturumda
 * normal kullanıcı varsa CMS hiçbir şey göstermez.
 */
export type MeProfile = {
  id: string;
  email: string | null;
  display_name: string | null;
  is_super_admin: boolean;
  role: string | null;
  industry_id: string | null;
  industry_service_ids: string[];
  setup_completed_at: string | null;
  setup_current_step: number;
  locale: string;
  avatar_url: string | null;
};

export type MePlan = {
  id: string | null;
  name: string | null;
};

export type MeResponse = {
  profile: MeProfile | null;
  plan: MePlan | null;
};

export const meApi = {
  get: async (): Promise<MeResponse> => {
    const { data } = await apiClient.get<MeResponse>("/api/saas/me");
    return data;
  },
};
